var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-12 pb-0 px-0",attrs:{"id":"portfolio","fluid":"","tag":"section"}},[_c('headline'),_c('gallery')],1)}
var staticRenderFns = []

export { render, staticRenderFns }